import { FC } from 'react'
import { observer } from 'mobx-react-lite'

const AddGameDialog: FC = observer(() => {
  return <div />
})

export default AddGameDialog
